import { NetworkSubordinate } from "./NetworkSubordinate";
import { DeviceClass } from "./DeviceClass";
import { ProtocolProfile } from "./ProtocolProfile";
import { ProtocolNames } from "../Protocols/ProtocolNames";
import { DeviceCategories } from "./DeviceCategories";
import { LinkSet } from "./LinkSet";
import { IComparable } from "../Utils/ObjUtils";
import { IpAddress } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { DependentDeviceId } from "./DependentDeviceId";
import { Dictionary } from "../Utils/Dictionary";
import { Guid } from "../Utils/Guid";
import { SmallSet } from "./NetworkDiffer";
import { DeviceKey } from "./Keys";
import { InfoSet } from "../InfoSets/InfoSet";
import { List } from "../Utils/List";
import { InfoSetNames } from "../InfoSets/InfoSetNames";
import { SystemInfo } from "../InfoSets/SystemInfo";
import { AssetTable, AssetPhysicalClass } from "../InfoSets/AssetTable";
import { StpPortTable } from "../InfoSets/StpPortTable";
import { IfArpTable } from "../InfoSets/IfArpTable";
import { BridgePortFdbTable } from "../InfoSets/BridgePortFdbTable";
import { BaseBridgeAddressTable } from "../InfoSets/BaseBridgeAddressTable";
import { ProductInfo } from "../InfoSets/ProductInfo";
import { AttributeInfo } from "../InfoSets/AttributeInfo";
import { HashSet } from "../Utils/HashSet";
import { EntPhysicalTable, EntPhysicalClass } from "../InfoSets/EntPhysicalTable";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { VirtualMachineInfo } from "../InfoSets/VirtualMachineInfo";
import { SensorTable } from "../InfoSets/SensorTable";
import { VirtualMachineTable } from "../InfoSets/VirtualMachineTable";
import { VirtualHostTable } from "../InfoSets/VirtualHostTable";
import { VirtualHostInfo } from "../InfoSets/VirtualHostInfo";
import { IfCdpTable } from "../InfoSets/IfCdpTable";
import { ApClientTable } from "../InfoSets/ApClientTable";
import { IpPhoneInfo } from "../InfoSets/IpPhoneInfo";
import { ApTable, ApEntry } from "../InfoSets/ApTable";
import { IpRouteTable } from "../InfoSets/IpRouteTable";
import { IpPhoneTable } from "../InfoSets/IpPhoneTable";
import { Win32_BIOSInfo } from "../InfoSets/Win32_BIOSInfo";
import { Win32_ComputerSystemInfo } from "../InfoSets/Win32_ComputerSystemInfo";
import { Win32_OperatingSystemInfo } from "../InfoSets/Win32_OperatingSystemInfo";
import { Win32_DiskDriveTable } from "../InfoSets/Win32_DiskDriveTable";
import { Win32_LogicalDiskTable } from "../InfoSets/Win32_LogicalDiskTable";
import { Win32_ProcessorTable } from "../InfoSets/Win32_ProcessorTable";
import { Win32_InstalledSoftwareTable } from "../InfoSets/Win32_InstalledSoftwareTable";
import { Win32_NetworkAdapterConfigTable } from "../InfoSets/Win32_NetworkAdapterConfigTable";
import { Win32_NetworkAdapterTable } from "../InfoSets/Win32_NetworkAdapterTable";
import { InstalledSoftwareTable } from "../InfoSets/InstalledSoftwareTable";
import { LagTable, LagEntry } from "../InfoSets/LagTable";
import { BridgePortTable } from "../InfoSets/BridgePortTable";
import { MacAddressTable, MacAddressEntry } from "../InfoSets/MacAddressTable";
import { IpAddressTable } from "../InfoSets/IpAddressTable";
import { PortLldpTable } from "../InfoSets/PortLldpTable";
import { ApIfTable, ApIfEntry } from "../InfoSets/ApIfTable";
import { VlanTable } from "../InfoSets/VlanTable";
import { AddressInfo } from "../InfoSets/AddressInfo";
import { VrrpTable } from "../InfoSets/VrrpTable";
import { IpV6_IfTable } from "../InfoSets/IpV6_IfTable";
import { NotesInfo } from "../InfoSets/NotesInfo";
import { SerialNumberInfo } from "./DeviceSet";
import { DeviceCategory } from "./DeviceCategory";
import { LinkMember } from "./LinkMember";
import { Link } from "./Link";
import { LinkMemberSet } from "./LinkMemberSet";
import { TriStateBool } from "./TriStateBool";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface DeviceJson {
//  ip_address: string;
//  mac_address: string;
//  guid: string;
//  info_sets: any;
//  device_categories: any;
//  timestamp: string;
//}

export enum DeviceDisplayNameSetting { Default = 0, Hostname = 1, IpAddress = 2 }

export class Device extends NetworkSubordinate implements IComparable, ObjectSerializer {

	//public static FromJson(json: DeviceJson, network: Network): Device {
	//  var result = new Device(network);

	//  if (json.device_categories !== undefined)
	//    result.Categories = DeviceCategories.FromJson(json.device_categories, network);

	//  if (json.info_sets !== undefined)
	//    result.InfoSets = InfoSet.AllFromJson(json.info_sets, result);

	//  if (json.guid !== undefined)
	//    result.GUID = Guid.FromString(json.guid);
	//  if (json.ip_address !== undefined)
	//    result.IpAddress = IpAddress.Create(json.ip_address);
	//  if (json.mac_address !== undefined)
	//    result.MacAddress = MacAddress.CreateFromString(json.mac_address);
	//  if (json.timestamp !== undefined)
	//    result.Timestamp = new Date(json.timestamp);

	//  return result;
	//}

	private static _3ComOID = "1.3.6.1.4.1.43.";
	private static ArubaOID = "1.3.6.1.4.1.14823.";
	private static AvayaOID = "1.3.6.1.4.1.6889.";
	private static CiscoOID = "1.3.6.1.4.1.9.";
	private static CiscoSmallBusinessOID = "1.3.6.1.4.1.9.6.";
	private static ColubrisOID = "1.3.6.1.4.1.8744.";
	private static DellPowerConnectOID = "1.3.6.1.4.1.674.10895.";
	private static EnterasysOID = "1.3.6.1.4.1.5624.";
	private static ExtremeNetworksOID = "1.3.6.1.4.1.1916.";
	private static FoundryOID = "1.3.6.1.4.1.1991.";
	private static HP_OID = "1.3.6.1.4.1.11.";
	private static HP_H3C_OID = "1.3.6.1.4.1.2011.";
	private static HP_HH3C_OID = "1.3.6.1.4.1.25506.";
	private static JuniperOID = "1.3.6.1.4.1.2636.";
	private static MeruNetworksOID = "1.3.6.1.4.1.15983.";
	private static MerakiOID = "1.3.6.1.4.1.29671.";
	private static NetGearOID = "1.3.6.1.4.1.4526.";
	private static RuckusOID = "1.3.6.1.4.1.25053.";
	private static MicrosoftOID = "1.3.6.1.4.1.311.";
	private static LinuxOID = "1.3.6.1.4.1.8072.3.2.10";


	public IpAddress: IpAddress;
	public MacAddress: MacAddress;
	public DependentDeviceId: DependentDeviceId;
	private InfoSets: Dictionary<string, InfoSet>;
	public Class: DeviceClass;
	public Categories: DeviceCategories;
	public ProtocolProfile: ProtocolProfile;
	public Links: LinkSet;
	public Timestamp: string;
	public GUID: Guid;
	public CompatibleDevices: SmallSet<Device>;
	public DependentDeviceGUID: Guid;
	public SNMP_Port: number;
	public SSH_Port: number;
	public Telnet_Port: number;
	public CustomDisplayName: string;
	public DisplayNameSetting: DeviceDisplayNameSetting;

	constructor(network?: any) {
		super(network);
		this.InfoSets = new Dictionary<string, InfoSet>();
		this.Class = new DeviceClass();
		this.Categories = new DeviceCategories();
		this.ProtocolProfile = new ProtocolProfile();
		this.Links = new LinkSet();
		this.Timestamp = "";
		this.GUID = Guid.Empty;
		this.DependentDeviceGUID = Guid.Empty;
		this.SNMP_Port = 0;
		this.SSH_Port = 0;
		this.Telnet_Port = 0;
		this.CustomDisplayName = "";
		this.DisplayNameSetting = DeviceDisplayNameSetting.Default;
	}

	//public Copy(network: Network): Device {
	//	//var copy = new Device(network);
	//	//XmlUtils.Copy(this, copy);
	//	//return copy;

	//	// TODO
	//	return new Device(network);
	//}

	//	public Device PartialCopy(Network network, HashSet < string > infoSetsToCopy)
	//{
	//	var copy = new Device(network);

	//	if (this.HasIpAddress)
	//		copy.IpAddress = (IpAddress)this.IpAddress.Clone();

	//	if (this.HasMacAddress)
	//		copy.MacAddress = (MacAddress)this.MacAddress.Clone();

	//	if (this.HasDependentDeviceId)
	//		copy.DependentDeviceId = XmlUtils.Copy(this.DependentDeviceId);

	//	if (this.HasGUID)
	//		copy.GUID = this.GUID;

	//	XmlUtils.Copy(this.Class, copy.Class);
	//	XmlUtils.Copy(this.Categories, copy.Categories);
	//	XmlUtils.Copy(this.ProtocolProfile, copy.ProtocolProfile);

	//	CopyInfoSetToDevice(DiscoveryEngine.InfoSets.InfoSetNames.SystemInfo, copy);
	//	CopyInfoSetToDevice(DiscoveryEngine.InfoSets.InfoSetNames.ProductInfo, copy);

	//	foreach(string infoSetName in infoSetsToCopy)
	//	{
	//		CopyInfoSetToDevice(infoSetName, copy);
	//	}

	//	return copy;
	//}

	//	private void CopyInfoSetToDevice(string infoSetName, Device otherDevice)
	//{
	//	if (this.HasInfoSet(infoSetName)) {
	//		InfoSet infoSet = this.GetInfoSet(infoSetName);
	//		InfoSet infoSetCopy = otherDevice.AddInfoSet(infoSetName);
	//		XmlUtils.Copy(infoSet, infoSetCopy);
	//	}
	//}

	public CreateKey(): DeviceKey {
		return DeviceKey.Create(this);
	}

	public toString(): string {
		return this.DisplayName;
	}

	public get HasDependentDeviceGUID(): boolean {
		return (this.DependentDeviceGUID != Guid.Empty);
	}

	public get HasSNMP_Port(): boolean {
		return (this.SNMP_Port > 0);
	}

	public get HasSSH_Port(): boolean {
		return (this.SSH_Port > 0);
	}

	public get HasTelnet_Port(): boolean {
		return (this.Telnet_Port > 0);
	}

	public get HasCustomDisplayName(): boolean {
		return !!this.CustomDisplayName;
	}

	public CompareTo(other: Device): number {
		if (!other) {
			return 1;
		} else {
			return this.DisplayName.localeCompare(other.DisplayName);
		}
	}

	public HasInfoSet(infoSetName: string): boolean {
		return this.InfoSets.ContainsKey(infoSetName);
	}

	public get HasTimestamp(): boolean {
		return !!this.Timestamp;
	}

	//	public InfoSet AddInfoSet(string infoSetName)
	//{
	//	Debug.Assert(!string.IsNullOrWhiteSpace(infoSetName));

	//	InfoSet result = null;
	//	if (!InfoSets.TryGetValue(infoSetName, out result)) {
	//		result = Engine.InfoSetRegistry.CreateInstance(infoSetName, this);
	//		Debug.Assert(result != null);
	//		InfoSets[infoSetName] = result;
	//	}

	//	Debug.Assert(result != null);
	//	return result;
	//}

	public GetInfoSet<K extends InfoSet>(infoSetName: string): K {
		return <K>this.InfoSets.Item(infoSetName);
	}

	public DetachInfoSet(infoSetName: string): InfoSet {
		var result: InfoSet = this.GetInfoSet(infoSetName);

		if (result != null) {
			this.InfoSets.Remove(infoSetName);
			result.Device = null;
		}

		return result;
	}

	public AttachInfoSet(infoSetName: string, infoSet: InfoSet): void {
		infoSet.Device = this;
		this.InfoSets.Add(infoSetName, infoSet);
	}

	public get InfoSetCount(): number {
		return this.InfoSets.Count;
	}

	public get InfoSetNames(): List<string> {
		var result = this.InfoSets.Keys();
		//result.Sort();
		return result;
	}

	public get HasSystemInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.SystemInfo);
	}

	public get SystemInfo(): SystemInfo {
		return this.GetInfoSet<SystemInfo>(InfoSetNames.SystemInfo);
	}

	public AddSystemInfo(): SystemInfo {
		var systemInfo: SystemInfo = this.SystemInfo;
		if (!systemInfo) {
			systemInfo = new SystemInfo(this);
			this.InfoSets.Add(InfoSetNames.SystemInfo, systemInfo);
		};
		return systemInfo;
	}

	public get HasNotesInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.NotesInfo);
	}

	public get NotesInfo(): NotesInfo {
		return this.GetInfoSet<NotesInfo>(InfoSetNames.NotesInfo);
	}

	public AddNotesInfo(): NotesInfo {
		var notesInfo: NotesInfo = this.NotesInfo;
		if (!notesInfo) {
			notesInfo = new NotesInfo(this);
			this.InfoSets.Add(InfoSetNames.NotesInfo, notesInfo);
		};
		return notesInfo;
	}

	public get HasAddressInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.AddressInfo);
	}

	public get AddressInfo(): AddressInfo {
		return this.GetInfoSet<AddressInfo>(InfoSetNames.AddressInfo);
	}

	public AddAddressInfo(): AddressInfo {
		let addressInfo: AddressInfo = this.AddressInfo;
		if (!addressInfo) {
			addressInfo = new AddressInfo(this);
			this.InfoSets.Add(InfoSetNames.AddressInfo, addressInfo);
		}
		return addressInfo;
	}

	public get HasAssetTable(): boolean {
		return this.HasInfoSet(InfoSetNames.AssetTable);
	}

	public get AssetTable(): AssetTable {
		return this.GetInfoSet<AssetTable>(InfoSetNames.AssetTable);
	}

	public AddAssetTable(): AssetTable {
		var assetTable: AssetTable = this.AssetTable;
		if (!assetTable) {
			assetTable = new AssetTable(this);
			this.InfoSets.Add(InfoSetNames.AssetTable, assetTable);
		}
		return assetTable;
	}

	public get HasStpPortTable(): boolean {
		return this.HasInfoSet(InfoSetNames.StpPortTable);
	}

	public get StpPortTable(): StpPortTable {
		return this.GetInfoSet<StpPortTable>(InfoSetNames.StpPortTable);
	}

	public AddStpPortTable(): StpPortTable {
		var stpPortTable: StpPortTable = this.StpPortTable;
		if (!stpPortTable) {
			stpPortTable = new StpPortTable(this);
			this.InfoSets.Add(InfoSetNames.StpPortTable, stpPortTable);
		}
		return stpPortTable;
	}

	public get HasIfArpTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IfArpTable);
	}

	public get IfArpTable(): IfArpTable {
		return this.GetInfoSet<IfArpTable>(InfoSetNames.IfArpTable);
	}

	public AddIfArpTable(): IfArpTable {
		var ifArpTable: IfArpTable = this.IfArpTable;
		if (!ifArpTable) {
			ifArpTable = new IfArpTable(this);
			this.InfoSets.Add(InfoSetNames.IfArpTable, ifArpTable);
		}
		return ifArpTable;
	}

	public get HasBridgePortFdbTable(): boolean {
		return this.HasInfoSet(InfoSetNames.BridgePortFdbTable);
	}

	public get BridgePortFdbTable(): BridgePortFdbTable {
		return this.GetInfoSet<BridgePortFdbTable>(InfoSetNames.BridgePortFdbTable);
	}

	public AddBridgePortFdbTable(): BridgePortFdbTable {
		var bridgePortFdbTable: BridgePortFdbTable = this.BridgePortFdbTable;
		if (!bridgePortFdbTable) {
			bridgePortFdbTable = new BridgePortFdbTable(this);
			this.InfoSets.Add(InfoSetNames.BridgePortFdbTable, bridgePortFdbTable);
		}
		return bridgePortFdbTable;
	}

	public get HasBaseBridgeAddressTable(): boolean {
		return this.HasInfoSet(InfoSetNames.BaseBridgeAddressTable);
	}

	public get BaseBridgeAddressTable(): BaseBridgeAddressTable {
		return this.GetInfoSet<BaseBridgeAddressTable>(InfoSetNames.BaseBridgeAddressTable);
	}

	public AddBaseBridgeAddressTable(): BaseBridgeAddressTable {
		var addrTable = this.BaseBridgeAddressTable;
		if (!addrTable) {
			addrTable = new BaseBridgeAddressTable(this);
			this.AttachInfoSet(InfoSetNames.BaseBridgeAddressTable, addrTable);
		}
		return addrTable;
	}

	public get HasProductInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.ProductInfo);
	}

	public get ProductInfo(): ProductInfo {
		return this.GetInfoSet<ProductInfo>(InfoSetNames.ProductInfo);
	}

	public AddProductInfo(): ProductInfo {
		var productInfo: ProductInfo = this.ProductInfo;
		if (!productInfo) {
			productInfo = new ProductInfo(this);
			this.InfoSets.Add(InfoSetNames.ProductInfo, productInfo);
		}
		return productInfo;
	}

	public get HasAttributeInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.AttributeInfo);
	}

	public get AttributeInfo(): AttributeInfo {
		return this.GetInfoSet<AttributeInfo>(InfoSetNames.AttributeInfo);
	}

	public AddAttributeInfo(): AttributeInfo {
		var attributeInfo: AttributeInfo = this.AttributeInfo;
		if (!attributeInfo) {
			attributeInfo = new AttributeInfo(this);
			this.InfoSets.Add(InfoSetNames.AttributeInfo, attributeInfo);
		}
		return attributeInfo;
	}

	public get HasHostname(): boolean {
		if (!this.HasSystemInfo)
			return false;
		var sysInfo: SystemInfo = this.SystemInfo;
		if (!sysInfo.HasHostname)
			return false;
		return true;
	}

	public get Hostname(): string {
		var hostName = '';

		if (this.HasSystemInfo) {
			var sysInfo: SystemInfo = this.SystemInfo;
			if (sysInfo.HasHostname)
				hostName = sysInfo.Hostname;
		}

		if (!hostName) {
			// TODO: Check the IP ADDRESS table
		}

		return hostName;
	}

	public get HasIpAddress(): boolean {
		return this.IpAddress ? true : false;
	}

	public get HasMacAddress(): boolean {
		return this.MacAddress && !this.MacAddress.IsNull;
	}

	public get HasNetBiosName(): boolean {
		if (!this.HasSystemInfo)
			return false;
		var sysInfo: SystemInfo = this.SystemInfo;
		if (!sysInfo.HasNetBiosName)
			return false;
		return true;
	}

	public get HasDependentDeviceId(): boolean {
		return (this.DependentDeviceId != null);
	}

	public get HasGUID(): boolean {
		return this.GUID != Guid.Empty;
	}

	public ClearGUID(): void {
		this.GUID = Guid.Empty;
	}
	public GenerateGUID(): void {
		if (!this.HasGUID) {
			this.GUID = Guid.Create();
		}
	}

	public SetGUID(newGUID: Guid): void {
		this.GUID = newGUID;
	}

	public VerifyGUID(): string {
		if (!this.HasGUID)
			this.GenerateGUID();
		return this.GUID.toString();
	}

	public ContainsIpAddress(ipAddress: IpAddress): boolean {
		return this.IpAddresses.Contains(ipAddress);
	}

	public get IpAddresses(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		// ADD MAIN IP ADDRESS
		if (this.HasIpAddress) {
			if (this.IpAddress.IsValidDiscoveryAddress)
				ipAddresses.Add(this.IpAddress);
		}

		this.InfoSets.ForEach((pair) => {
			if (!pair.Value.HasIpAddresses)
				return;

			ipAddresses.UnionWith(pair.Value.IpAddresses);
		});

		return (ipAddresses);
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		// INSPECT all INFOSETs to see if they have IP addresses to ADD to this SET
		this.InfoSets.ForEach((pair) => {
			if (!pair.Value.HasIpSightings)
				return;

			ipAddresses.UnionWith(pair.Value.IpSightings);
		});

		return (ipAddresses);
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		// ADD MAIN MAC ADDRESS
		if (this.HasMacAddress)
			macAddresses.Add(this.MacAddress);

		this.InfoSets.ForEach((pair) => {
			if (!pair.Value.HasMacAddresses)
				return;

			macAddresses.UnionWith(pair.Value.MacAddresses);
		});

		return macAddresses;
	}

	public get MacSightings(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		// ADD MAIN MAC ADDRESS
		if (this.HasMacAddress)
			macAddresses.Add(this.MacAddress);



		this.InfoSets.ForEach((pair) => {
			if (!pair.Value.HasMacSightings)
				return;

			macAddresses.UnionWith(pair.Value.MacSightings);
		});

		return macAddresses;
	}

	public get EntPhysicalTable(): EntPhysicalTable {
		return this.GetInfoSet<EntPhysicalTable>(InfoSetNames.EntPhysicalTable);
	}

	public get HasEntPhysicalTable(): boolean {
		return this.HasInfoSet(InfoSetNames.EntPhysicalTable);
	}

	public AddEntPhysicalTable(): EntPhysicalTable {
		var entPhysicalTable: EntPhysicalTable = this.EntPhysicalTable;
		if (!entPhysicalTable) {
			entPhysicalTable = new EntPhysicalTable(this);
			this.InfoSets.Add(InfoSetNames.EntPhysicalTable, entPhysicalTable);
		}
		return entPhysicalTable;
	}

	public get IfTable(): IfTable {
		return this.GetInfoSet<IfTable>(InfoSetNames.IfTable);
	}

	public get HasIfTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IfTable);
	}

	public AddIfTable(): IfTable {
		var table = this.IfTable;
		if (!table) {
			table = new IfTable(this);
			this.AttachInfoSet(InfoSetNames.IfTable, table);
		}
		return table;
	}

	public get IpV6_IfTable(): IpV6_IfTable {
		return this.GetInfoSet<IpV6_IfTable>(InfoSetNames.IpV6_IfTable);
	}

	public get HasIpV6_IfTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IpV6_IfTable);
	}

	public AddIpV6_IfTable(): IpV6_IfTable {
		var table = this.IpV6_IfTable;
		if (!table) {
			table = new IpV6_IfTable(this);
			this.AttachInfoSet(InfoSetNames.IpV6_IfTable, table);
		}
		return table;
	}

	public get HasVirtualMachineInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.VirtualMachineInfo);
	}

	public get VirtualMachineInfo(): VirtualMachineInfo {
		return this.GetInfoSet<VirtualMachineInfo>(InfoSetNames.VirtualMachineInfo);
	}

	public AddVirtualMachineInfo(): VirtualMachineInfo {
		var info = this.VirtualMachineInfo;
		if (!info) {
			info = new VirtualMachineInfo(this);
			this.AttachInfoSet(InfoSetNames.VirtualMachineInfo, info);
		}
		return info;
	}

	public get HasVirtualMachineTable(): boolean {
		return this.HasInfoSet(InfoSetNames.VirtualMachineTable);
	}

	public get VirtualMachineTable(): VirtualMachineTable {
		return this.GetInfoSet<VirtualMachineTable>(InfoSetNames.VirtualMachineTable);
	}

	public AddVirtualMachineTable(): VirtualMachineTable {
		var virtualMachineTable: VirtualMachineTable = this.VirtualMachineTable;
		if (!virtualMachineTable) {
			virtualMachineTable = new VirtualMachineTable(this);
			this.InfoSets.Add(InfoSetNames.VirtualMachineTable, virtualMachineTable);
		}
		return virtualMachineTable;
	}

	public get HasVirtualHostTable(): boolean {
		return this.HasInfoSet(InfoSetNames.VirtualHostTable);
	}

	public get VirtualHostTable(): VirtualHostTable {
		return this.GetInfoSet<VirtualHostTable>(InfoSetNames.VirtualHostTable);
	}

	public AddVirtualHostTable(): VirtualHostTable {
		var virtualHostTable: VirtualHostTable = this.VirtualHostTable;
		if (!virtualHostTable) {
			virtualHostTable = new VirtualHostTable(this);
			this.InfoSets.Add(InfoSetNames.VirtualHostTable, virtualHostTable);
		}
		return virtualHostTable;
	}

	public get VirtualHostInfo(): VirtualHostInfo {
		return this.GetInfoSet<VirtualHostInfo>(InfoSetNames.VirtualHostInfo);
	}

	public get HasVirtualHostInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.VirtualHostInfo);
	}

	public AddVirtualHostInfo(): VirtualHostInfo {
		var virtualHostInfo: VirtualHostInfo = this.VirtualHostInfo;
		if (!virtualHostInfo) {
			virtualHostInfo = new VirtualHostInfo(this);
			this.InfoSets.Add(InfoSetNames.VirtualHostInfo, virtualHostInfo);
		}
		return virtualHostInfo;
	}

	public get HasIfCdpTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IfCdpTable);
	}

	public get IfCdpTable(): IfCdpTable {
		return this.GetInfoSet<IfCdpTable>(InfoSetNames.IfCdpTable);
	}

	public AddIfCdpTable(): IfCdpTable {
		var ifCdpTable: IfCdpTable = this.IfCdpTable;
		if (!ifCdpTable) {
			ifCdpTable = new IfCdpTable(this);
			this.InfoSets.Add(InfoSetNames.IfCdpTable, ifCdpTable);
		}
		return ifCdpTable;
	}

	public get HasApClientTable(): boolean {
		return this.HasInfoSet(InfoSetNames.ApClientTable);
	}

	public get ApClientTable(): ApClientTable {
		return this.GetInfoSet<ApClientTable>(InfoSetNames.ApClientTable);
	}

	public AddApClientTable(): ApClientTable {
		var apClientTable: ApClientTable = this.ApClientTable;
		if (!apClientTable) {
			apClientTable = new ApClientTable(this);
			this.InfoSets.Add(InfoSetNames.ApClientTable, apClientTable);
		}
		return apClientTable;
	}

	public get HasIpPhoneInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.IpPhoneInfo);
	}

	public get IpPhoneInfo(): IpPhoneInfo {
		return this.GetInfoSet<IpPhoneInfo>(InfoSetNames.IpPhoneInfo);
	}

	public AddIpPhoneInfo(): IpPhoneInfo {
		var info = this.IpPhoneInfo;
		if (!info) {
			info = new IpPhoneInfo(this);
			this.AttachInfoSet(InfoSetNames.IpPhoneInfo, info);
		}
		return info;
	}

	public get HasApTable(): boolean {
		return this.HasInfoSet(InfoSetNames.ApTable);
	}

	public get ApTable(): ApTable {
		return this.GetInfoSet<ApTable>(InfoSetNames.ApTable);
	}

	public AddApTable(): ApTable {
		var apTable: ApTable = this.ApTable;
		if (!apTable) {
			apTable = new ApTable(this);
			this.InfoSets.Add(InfoSetNames.ApTable, apTable);
		}
		return apTable;
	}

	public get HasIpRouteTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IpRouteTable);
	}

	public get IpRouteTable(): IpRouteTable {
		return this.GetInfoSet<IpRouteTable>(InfoSetNames.IpRouteTable);
	}

	public AddIpRouteTable(): IpRouteTable {
		var ipRouteTable: IpRouteTable = this.IpRouteTable;
		if (!ipRouteTable) {
			ipRouteTable = new IpRouteTable(this);
			this.InfoSets.Add(InfoSetNames.IpRouteTable, ipRouteTable);
		}
		return ipRouteTable;
    }


    public AddWin32_BIOSInfo(): Win32_BIOSInfo {
        var win32_BIOSInfo: Win32_BIOSInfo = this.Win32_BIOSInfo;
        if (!win32_BIOSInfo) {
            win32_BIOSInfo = new Win32_BIOSInfo(this);
            this.InfoSets.Add(InfoSetNames.Win32_BIOSInfo, win32_BIOSInfo);
        }
        return win32_BIOSInfo;
    }

    public get Win32_BIOSInfo(): Win32_BIOSInfo {
        return this.GetInfoSet<Win32_BIOSInfo>(InfoSetNames.Win32_BIOSInfo);
    }

    public get HasWin32_BIOSInfo(): boolean {
        return this.HasInfoSet(InfoSetNames.Win32_BIOSInfo);
    }


	public get HasWin32_ComputerSystemInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_ComputerSystemInfo);
	}

	public get Win32_ComputerSystemInfo(): Win32_ComputerSystemInfo {
		return this.GetInfoSet<Win32_ComputerSystemInfo>(InfoSetNames.Win32_ComputerSystemInfo);
	}

	public AddWin32_ComputerSystemInfo(): Win32_ComputerSystemInfo {
		var win32_ComputerSystemInfo: Win32_ComputerSystemInfo = this.Win32_ComputerSystemInfo;
		if (!win32_ComputerSystemInfo) {
			win32_ComputerSystemInfo = new Win32_ComputerSystemInfo(this);
			this.InfoSets.Add(InfoSetNames.Win32_ComputerSystemInfo, win32_ComputerSystemInfo);
		}
		return win32_ComputerSystemInfo;
	}

	public get HasWin32_OperatingSystemInfo(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_OperatingSystemInfo);
	}

	public get Win32_OperatingSystemInfo(): Win32_OperatingSystemInfo {
		return this.GetInfoSet<Win32_OperatingSystemInfo>(InfoSetNames.Win32_OperatingSystemInfo);
	}

	public AddWin32_OperatingSystemInfo(): Win32_OperatingSystemInfo {
		var win32_OperatingSystemInfo: Win32_OperatingSystemInfo = this.Win32_OperatingSystemInfo;
		if (!win32_OperatingSystemInfo) {
			win32_OperatingSystemInfo = new Win32_OperatingSystemInfo(this);
			this.InfoSets.Add(InfoSetNames.Win32_OperatingSystemInfo, win32_OperatingSystemInfo);
		}
		return win32_OperatingSystemInfo;
	}

	public get HasWin32_DiskDriveTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_DiskDriveTable);
	}

	public get Win32_DiskDriveTable(): Win32_DiskDriveTable {
		return this.GetInfoSet<Win32_DiskDriveTable>(InfoSetNames.Win32_DiskDriveTable);
	}

	public AddWin32_DiskDriveTable(): Win32_DiskDriveTable {
		var win32_DiskDriveTable: Win32_DiskDriveTable = this.Win32_DiskDriveTable;
		if (!win32_DiskDriveTable) {
			win32_DiskDriveTable = new Win32_DiskDriveTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_DiskDriveTable, win32_DiskDriveTable);
		}
		return win32_DiskDriveTable;
	}
	
	public get HasWin32_LogicalDiskTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_LogicalDiskTable);
	}

	public get Win32_LogicalDiskTable(): Win32_LogicalDiskTable {
		return this.GetInfoSet<Win32_LogicalDiskTable>(InfoSetNames.Win32_LogicalDiskTable);
	}

	public AddWin32_LogicalDiskTable(): Win32_LogicalDiskTable {
		var win32_LogicalDiskTable: Win32_LogicalDiskTable = this.Win32_LogicalDiskTable;
		if (!win32_LogicalDiskTable) {
			win32_LogicalDiskTable = new Win32_LogicalDiskTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_LogicalDiskTable, win32_LogicalDiskTable);
		}
		return win32_LogicalDiskTable;
	}

	public get HasWin32_ProcessorTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_ProcessorTable);
	}

	public get Win32_ProcessorTable(): Win32_ProcessorTable {
		return this.GetInfoSet<Win32_ProcessorTable>(InfoSetNames.Win32_ProcessorTable);
	}

	public AddWin32_ProcessorTable(): Win32_ProcessorTable {
		var win32_ProcessorTable: Win32_ProcessorTable = this.Win32_ProcessorTable;
		if (!win32_ProcessorTable) {
			win32_ProcessorTable = new Win32_ProcessorTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_ProcessorTable, win32_ProcessorTable);
		}
		return win32_ProcessorTable;
	}

	public get HasWin32_InstalledSoftwareTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_InstalledSoftwareTable);
	}

	public get Win32_InstalledSoftwareTable(): Win32_InstalledSoftwareTable {
		return this.GetInfoSet<Win32_InstalledSoftwareTable>(InfoSetNames.Win32_InstalledSoftwareTable);
	}

	public AddWin32_InstalledSoftwareTable(): Win32_InstalledSoftwareTable {
		var win32_InstalledSoftwareTable: Win32_InstalledSoftwareTable = this.Win32_InstalledSoftwareTable;
		if (!win32_InstalledSoftwareTable) {
			win32_InstalledSoftwareTable = new Win32_InstalledSoftwareTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_InstalledSoftwareTable, win32_InstalledSoftwareTable);
		}
		return win32_InstalledSoftwareTable;
	}

	public get HasWin32_NetworkAdapterConfigTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_NetworkAdapterConfigTable);
	}

	public get Win32_NetworkAdapterConfigTable(): Win32_NetworkAdapterConfigTable {
		return this.GetInfoSet<Win32_NetworkAdapterConfigTable>(InfoSetNames.Win32_NetworkAdapterConfigTable);
	}

	public AddWin32_NetworkAdapterConfigTable(): Win32_NetworkAdapterConfigTable {
		var win32_NetworkAdapterConfigTable: Win32_NetworkAdapterConfigTable = this.Win32_NetworkAdapterConfigTable;
		if (!win32_NetworkAdapterConfigTable) {
			win32_NetworkAdapterConfigTable = new Win32_NetworkAdapterConfigTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_NetworkAdapterConfigTable, win32_NetworkAdapterConfigTable);
		}
		return win32_NetworkAdapterConfigTable;
	}

	public get HasWin32_NetworkAdapterTable(): boolean {
		return this.HasInfoSet(InfoSetNames.Win32_NetworkAdapterTable);
	}

	public get Win32_NetworkAdapterTable(): Win32_NetworkAdapterTable {
		return this.GetInfoSet<Win32_NetworkAdapterTable>(InfoSetNames.Win32_NetworkAdapterTable);
	}

	public AddWin32_NetworkAdapterTable(): Win32_NetworkAdapterTable {
		var win32_NetworkAdapterTable: Win32_NetworkAdapterTable = this.Win32_NetworkAdapterTable;
		if (!win32_NetworkAdapterTable) {
			win32_NetworkAdapterTable = new Win32_NetworkAdapterTable(this);
			this.InfoSets.Add(InfoSetNames.Win32_NetworkAdapterTable, win32_NetworkAdapterTable);
		}
		return win32_NetworkAdapterTable;
	}

	public get HasInstalledSoftwareTable(): boolean {
		return this.HasInfoSet(InfoSetNames.InstalledSoftwareTable);
	}

	public get InstalledSoftwareTable(): InstalledSoftwareTable {
		return this.GetInfoSet<InstalledSoftwareTable>(InfoSetNames.InstalledSoftwareTable);
	}

	public AddInstalledSoftwareTable(): InstalledSoftwareTable {
		var installedSoftwareTable: InstalledSoftwareTable = this.InstalledSoftwareTable;
		if (!installedSoftwareTable) {
			installedSoftwareTable = new InstalledSoftwareTable(this);
			this.InfoSets.Add(InfoSetNames.InstalledSoftwareTable, installedSoftwareTable);
		}
		return installedSoftwareTable;
	}

	public get HasVrrpTable(): boolean {
		return this.HasInfoSet(InfoSetNames.VrrpTable);
	}

	public get VrrpTable(): VrrpTable {
		return this.GetInfoSet<VrrpTable>(InfoSetNames.VrrpTable);
	}

	public AddVrrpTable(): VrrpTable {
		var vrrpTable: VrrpTable = this.VrrpTable;
		if (!vrrpTable) {
			vrrpTable = new VrrpTable(this);
			this.InfoSets.Add(InfoSetNames.VrrpTable, vrrpTable);
		}
		return vrrpTable;
	}

	public get SerialNumbers() {
		var result = new HashSet<SerialNumberInfo>();

		if (this.HasAssetTable) {
			this.AssetTable.ForEach((entry) => {
				if (entry.Class == AssetPhysicalClass.chassis ||
					entry.Class == AssetPhysicalClass.module) {
					if (entry.HasSerialNum) {
						result.Add(new SerialNumberInfo(entry.SerialNum));
					}
				}
			});
		}

		if (this.HasEntPhysicalTable) {
			this.EntPhysicalTable.ForEach((entry) => {
				if (entry.Class == EntPhysicalClass.chassis ||
					entry.Class == EntPhysicalClass.module) {
					if (entry.HasSerialNum) {
						result.Add(new SerialNumberInfo(entry.SerialNum));
					}
				}
			});
		}

		return result;
	}

	public get SerialNumber(): string {
		var serialNumber = '';

		var serialNumbers: HashSet<SerialNumberInfo> = this.SerialNumbers;
		if ((serialNumbers != null) && (serialNumbers.Count > 0)) {
			serialNumbers.Some((serialInfo) => {
				serialNumber = serialInfo.SerialNumber;
				return true;
			});
		}

		return (serialNumber);
	}

	public get Model(): string {
		var model = '';

		if (this.HasAssetTable) {
			this.AssetTable.Some((entry) => {
				if (entry.Class == AssetPhysicalClass.chassis ||
					entry.Class == AssetPhysicalClass.module) {
					if (!entry.HasModelName)
						return;

					model = entry.ModelName;
					return true;
				}
			});
		}

		if (!model) {
		}

		return (model);
	}

	public get DisplayName(): string {
		let displayName = '';

		if (this.HasIpAddress)
			displayName = this.IpAddress.toString();

		if (this.HasCustomDisplayName) {
			displayName = this.CustomDisplayName;
		}
		else {
			// LOOK for a BETTER DISPLAY NAME
			if (this.HasSystemInfo) {
				let sysInfo: SystemInfo = this.SystemInfo;

				if (this.DisplayNameSetting == DeviceDisplayNameSetting.Hostname) {
					if (sysInfo.HasHostname)
						displayName = sysInfo.Hostname;
					else if (sysInfo.HasSystemName)
						displayName = sysInfo.SystemName;
					else if (sysInfo.HasNetBiosName)
						displayName = sysInfo.NetBiosName;
				}
				else if (this.DisplayNameSetting == DeviceDisplayNameSetting.IpAddress) {
					if (this.HasIpAddress)
						displayName = this.IpAddress.ToString();
					else if (sysInfo.HasSystemName)
						displayName = sysInfo.SystemName;
					else if (sysInfo.HasHostname)
						displayName = sysInfo.Hostname;
					else if (sysInfo.HasNetBiosName)
						displayName = sysInfo.NetBiosName;
				}
				else {
					if (sysInfo.HasSystemName)
						displayName = sysInfo.SystemName;
					else if (sysInfo.HasHostname)
						displayName = sysInfo.Hostname;
					else if (sysInfo.HasNetBiosName)
						displayName = sysInfo.NetBiosName;
				}
			}
		}

		if (!displayName) {
			if (this.HasDependentDeviceId)
				displayName = this.DependentDeviceId.ControllerLabel;
		}

		return (displayName);
	}

	public get DisplayDescription(): string {
		var displayDescr = '';

		if (this.HasSystemInfo) {
			var sysInfo: SystemInfo = this.SystemInfo;

			if (sysInfo.HasSystemDescription)
				displayDescr = sysInfo.SystemDescription;
		}
		return (displayDescr);
	}

	public get SystemOID(): string {
		var sysOID = '';
		if (this.HasSystemInfo) {
			var sysInfo: SystemInfo = this.SystemInfo;

			if (sysInfo.HasSystemOID)
				sysOID = sysInfo.SystemOID;
		}
		return (sysOID);
	}

	public get NetBiosName(): string {
		var nbName = '';

		if (this.HasSystemInfo) {
			var sysInfo: SystemInfo = this.SystemInfo;

			if (sysInfo.HasNetBiosName)
				nbName = sysInfo.NetBiosName;
		}

		return nbName;
	}

	//public GetDeviceState(details: DeviceStateDetails = null): DeviceState {
	//if (this.HasMonitorStateHistory) {
	//	MonitorStateDetails monStateDetails = ((details != null) ? new MonitorStateDetails() : null);
	//	var monStateResult = this.MonitorStateHistory.GetMonitorState(monStateDetails);
	//	MonitorState monState = monStateResult.State;

	//	if (details != null) {
	//		details.Initialize(monStateDetails);

	//		Debug.Assert(monStateResult.HasFirstTime);
	//		details.FirstTime = monStateResult.FirstTime;

	//		Debug.Assert(monStateResult.HasLastTime);
	//		details.LastTime = monStateResult.LastTime;
	//	}

	//	return (DeviceState)monState;
	//}
	//else {
	//	if (details != null) {
	//		details.State = DeviceState.NoData;
	//		details.FirstTime = default(DateTime);
	//	}

	//	return DeviceState.NoData;
	//}
	//}

	//	public ClearCollectedValues(): void {
	//		if (this.HasMonitorTable) {
	//			this.MonitorTable.ClearCollectedValues();
	//		}

	//		if (this.HasMonitorStateHistory) {
	//			this.MonitorStateHistory.Clear();
	//		}
	//	}

	//	public void ClearCollectedValues(Guid monitorPolicyId)
	//{
	//	if (this.HasMonitorTable) {
	//		this.MonitorTable.ClearCollectedValues(monitorPolicyId);
	//	}

	//	if (this.HasMonitorStateHistory) {
	//		this.MonitorStateHistory.Clear(monitorPolicyId);
	//	}
	//}

	//	public void RemoveAllMonitorPolicyData(Guid monitorPolicyId)
	//{
	//	if (this.HasMonitorTable) {
	//		this.MonitorTable.RemoveByMonitorPolicy(monitorPolicyId);
	//	}

	//	if (this.HasMonitorStateHistory) {
	//		this.MonitorStateHistory.Clear(monitorPolicyId);
	//	}
	//}

	public IsSnmpDevice(): boolean {
		var isSnmp = false;

		if (this.HasSystemInfo) {
			var sysInfo: SystemInfo = this.SystemInfo;

			if (sysInfo.HasSystemOID)
				isSnmp = true;
			else if (this.ProtocolProfile.ContainsProtocolName(ProtocolNames.Snmp))
				isSnmp = true;

			//else if (sysInfo.HasSystemDescription)
			//	isSnmp = true;

			// VERIFY that we have a SNMP credential
			//if (isSnmp) {
			//ProtocolSettings protoSettings = this.ProtocolProfile.FindSettingsForProtocol(ProtocolNames.Snmp);
			//if (protoSettings == null)
			//	isSnmp = false;
			//}
		}

		return (isSnmp);
	}

	public IsNetworkDevice(): boolean {
		return this.Categories.Contains(DeviceCategory.NetworkDevice);
	}

	public IsFirewall(): boolean {
		return this.Categories.Contains(DeviceCategory.Firewall);
	}

	public IsNetworkRouter(): boolean {
		return this.Categories.Contains(DeviceCategory.Router);
	}

	public IsNetworkSwitch(): boolean {
		return this.Categories.Contains(DeviceCategory.Switch);
	}

	public IsWirelessController(): boolean {
		return this.Categories.Contains(DeviceCategory.WirelessController);
	}

	public IsVMwareServer(): boolean {
		if (this.Categories.Contains(DeviceCategory.VMwareVsphere))
			return true;
		if (this.Categories.Contains(DeviceCategory.VMwareVcenter))
			return true;
		return false;
	}

	public IsWindowsServer(): boolean {
		return this.Categories.Contains(DeviceCategory.WindowsServer);
	}

	public IsWindowsWorkstation(): boolean {
		var isWindowsWorkstation: boolean = this.Categories.Contains(DeviceCategory.Windows);
		if (isWindowsWorkstation)
			isWindowsWorkstation = this.Categories.Contains(DeviceCategory.Workstation);
		return isWindowsWorkstation;
	}

	public IsApple(): boolean {
		return this.Categories.Contains(DeviceCategory.Apple);
	}

	public IsLinuxServer(): boolean {
		var isLinuxServer: boolean = this.Categories.Contains(DeviceCategory.Linux);
		if (isLinuxServer)
			isLinuxServer = this.Categories.Contains(DeviceCategory.Server);
		return isLinuxServer;
	}

	public IsLinuxWorkstation(): boolean {
		return this.Categories.Contains(DeviceCategory.Linux);
	}

	public IsPrinter(): boolean {
		return this.Categories.Contains(DeviceCategory.Printer);
	}

	public IsIpPhoneManager(): boolean {
		return this.Categories.Contains(DeviceCategory.IpPhoneManager);
	}

	public IsIpPhone(): boolean {
		return this.Categories.Contains(DeviceCategory.IpPhone);
	}


	public IsCoreDevice(): boolean {
		return this.Categories.Contains(DeviceCategory.CoreDevice);
	}

	private IsVendorDevice(vendorOID: string): boolean {
		if (!vendorOID)
			return false;

		if (!this.HasSystemInfo)
			return false;

		var sysOID: string = this.SystemInfo.SystemOID;
		if (!sysOID)
			return false;

		if (sysOID.indexOf(vendorOID) == 0)
			return true;

		return false;
	}

	public get Is3ComDevice(): boolean {
		return (this.IsVendorDevice(Device._3ComOID));
	}

	public get IsArubaDevice(): boolean {
		return (this.IsVendorDevice(Device.ArubaOID));
	}

	public get IsAvayaDevice(): boolean {
		return (this.IsVendorDevice(Device.AvayaOID));
	}

	public get IsCiscoDevice(): boolean {
		return (this.IsVendorDevice(Device.CiscoOID));
	}

	public get IsCiscoSmallBusinessDevice(): boolean {
		return (this.IsVendorDevice(Device.CiscoSmallBusinessOID));
	}

	public get IsColubrisDevice(): boolean {
		return (this.IsVendorDevice(Device.ColubrisOID));
	}

	public get IsDellPowerConnectDevice(): boolean {
		return (this.IsVendorDevice(Device.DellPowerConnectOID));
	}

	public get IsEnterasysDevice(): boolean {
		return (this.IsVendorDevice(Device.EnterasysOID));
	}

	public get IsExtremeNetworksDevice(): boolean {
		return (this.IsVendorDevice(Device.ExtremeNetworksOID));
	}

	public get IsFoundryDevice(): boolean {
		return (this.IsVendorDevice(Device.FoundryOID));
	}

	public get IsHpDevice(): boolean {
		if (this.IsVendorDevice(Device.HP_OID))
			return true;
		if (this.IsVendorDevice(Device.HP_H3C_OID))
			return true;
		if (this.IsVendorDevice(Device.HP_HH3C_OID))
			return true;
		return false;
	}

	public get IsHH3C_Device(): boolean {
		return (this.IsVendorDevice(Device.HP_HH3C_OID));
	}

	public get IsJuniperDevice(): boolean {
		return (this.IsVendorDevice(Device.JuniperOID));
	}

	public get IsLinuxDevice(): boolean {
		return (this.IsVendorDevice(Device.LinuxOID));
	}

	public get IsMerakiDevice(): boolean {
		return (this.IsVendorDevice(Device.MerakiOID));
	}

	public get IsMeruNetworks(): boolean {
		return (this.IsVendorDevice(Device.MeruNetworksOID));
	}

	public get IsMicrosoftWindows(): boolean {
		return (this.IsVendorDevice(Device.MicrosoftOID));
	}

	public get IsNetGear(): boolean {
		return (this.IsVendorDevice(Device.NetGearOID));
	}

	public get IsRuckus(): boolean {
		return (this.IsVendorDevice(Device.RuckusOID));
	}

	public get IsWirelessAP(): boolean {
		if (this.Categories != null) {
			if (this.Categories.Contains(DeviceCategory.WirelessAp))
				return true;
		}

		if (!this.HasIfTable)
			return false;

		return this.IfTable.Some((ifEntry) => {
			if (ifEntry.IsDot11Radio)
				return true;
		});
	}

	// NOTE: We may want to RETURN which device is the PRIMARY (or keeper)
	public IsDuplicateDevice(device: Device): boolean {
		if (device == null)
			return false;

		// COMPARING the SAME device is not considered a DUPLICATE
		if (this == device)
			return false;

		var isDuplicate = false;

		var isSnmpA = this.IsSnmpDevice();
		var isSnmpB = device.IsSnmpDevice();

		var sameSytemInfo: boolean = null;
		var sameMacInfo: boolean = this.HasCommonMacAddresses(device);

		var hasCommonMacs = false;

		var hasSysInfoA = this.HasSystemInfo;
		var hasSysInfoB = device.HasSystemInfo;

		if (isSnmpA && isSnmpB) {
			var sysInfoA: SystemInfo = this.SystemInfo;
			var sysInfoB: SystemInfo = device.SystemInfo;

			sameSytemInfo = sysInfoA.IsDuplicate(sysInfoB);

			if (sameMacInfo == true)
				hasCommonMacs = true;
			else if (sameMacInfo == false)
				hasCommonMacs = false;
			else
				hasCommonMacs = false;

			if ((sameSytemInfo == true) && hasCommonMacs)
				isDuplicate = true;
		}
		else if (isSnmpA && !isSnmpB) {
			//TODO:
		}
		else if (!isSnmpA && isSnmpB) {
			//TODO:
		}
		else {
			if (hasSysInfoA && hasSysInfoB) {
				sameSytemInfo = this.SystemInfo.IsDuplicateNetBios(device.SystemInfo);
				if (sameSytemInfo == true)
					isDuplicate = true;
			}
		}

		return (isDuplicate);
	}

	private HasCommonMacAddresses(otherDevice: Device): boolean {
		if (otherDevice == null)
			return (false);

		var myMacAddresses: HashSet<MacAddress> = this.MacAddresses;
		var otherMacAddresses: HashSet<MacAddress> = otherDevice.MacAddresses;

		var myTotalMacCount = 0;
		var otherTotalMacCount = 0;

		// GET all the MAC ADDRESSES from each DEVICE
		myTotalMacCount = myMacAddresses.Count;
		otherTotalMacCount = otherMacAddresses.Count;

		// NOTE: If EITHER of the DEVICES don't have ANY MAC ADDRESSES; NO DECISION can be made
		if ((myTotalMacCount <= 0) || (otherTotalMacCount <= 0))
			return null;

		// *********************************
		// CALCULATE containment / ownership
		var hasCommonMacs: boolean = null;

		var mySharedMacCount = 0;
		var mySharedPerct = 0.0;

		var otherSharedMacCount = 0;
		var otherSharedPerct = 0.0;

		if (myTotalMacCount > 0) {
			myMacAddresses.ForEach((macAddress) => {
				if (otherMacAddresses.Contains(macAddress))
					mySharedMacCount++;
			});

			mySharedPerct = mySharedMacCount / myTotalMacCount;
		}

		if (otherTotalMacCount > 0) {
			otherMacAddresses.ForEach((macAddress) => {
				if (myMacAddresses.Contains(macAddress))
					otherSharedMacCount++;
			});

			otherSharedPerct = otherSharedMacCount / otherTotalMacCount;
		}

		// DECIDE
		if ((mySharedPerct <= 0.0) || (otherSharedPerct <= 0.0)) {
			// NO COMMON MAC ADDRESSES - ANSWER IS DEFINITE "NO"
			hasCommonMacs = false;
		}
		else if ((mySharedPerct == 1.0) || (otherSharedPerct == 1.0)) {
			// EXACT MATCH (on ALL MAC ADDRESSES) - ANSWER IS DEFINITE "YES"
			hasCommonMacs = true;
		}
		else if ((mySharedPerct > 0.0) && (otherSharedPerct > 0.0)) {
			// TODO: DECISIONS - DECISIONS
			hasCommonMacs = null;
		}

		return (hasCommonMacs);
	}

	public get IsLinked(): boolean {
		if (!this.Links.IsEmpty)
			return true;

		if (this.HasIfTable) {
			if (this.IfTable.IsLinked)
				return true;
		}
		return false;
	}

	public get HasLagTable(): boolean {
		return this.HasInfoSet(InfoSetNames.LagTable);
	}

	public get LagTable(): LagTable {
		return this.GetInfoSet<LagTable>(InfoSetNames.LagTable);
	}

	public AddLagTable(): LagTable {
		var lagTable: LagTable = this.LagTable;
		if (!lagTable) {
			lagTable = new LagTable(this);
			this.InfoSets.Add(InfoSetNames.LagTable, lagTable);
		}
		return lagTable;
	}

	public get HasBridgePortTable(): boolean {
		return this.HasInfoSet(InfoSetNames.BridgePortTable);
	}

	public get BridgePortTable(): BridgePortTable {
		return this.GetInfoSet<BridgePortTable>(InfoSetNames.BridgePortTable);
	}

	public AddBridgePortTable(): BridgePortTable {
		var bridgePortTable: BridgePortTable = this.BridgePortTable;
		if (!bridgePortTable) {
			bridgePortTable = new BridgePortTable(this);
			this.InfoSets.Add(InfoSetNames.BridgePortTable, bridgePortTable);
		}
		return bridgePortTable;
	}

	public IsLagLinked(lagIfEntry: IfEntry): boolean {
		if (lagIfEntry == null)
			return false;

		if (lagIfEntry.IsLinked)
			return true;

		if (!lagIfEntry.IsLagInterface)
			return false;

		if (this.HasLagTable) {
			var lagTable: LagTable = this.LagTable;
			var lagEntry: LagEntry = lagTable.FindLagContaining(lagIfEntry.IfIndex);
			if (lagEntry != null) {
				var ifEntry: IfEntry = null;

				return lagEntry.Ports.ToPortList().some((portIndex) => {
					ifEntry = this.IfTable.Find(portIndex);
					if (ifEntry == null)
						return;

					ifEntry = ifEntry.PhysicalIfEntry;
					if (ifEntry == null)
						return;

					if (ifEntry.IsLinked)
						return true;
				});
			} else {
				return true;
			}
		}

		return false;
	}

	public IsValidLag(lagEntry: LagEntry): boolean {
		if (lagEntry == null)
			return false;
		if (!this.HasIfTable)
			return false;

		var isValidLag = false;

		var ifTable: IfTable = this.IfTable;
		var ifEntry: IfEntry = null;

		ifEntry = ifTable.Find(lagEntry.Index);
		if (ifEntry != null) {
			if (ifEntry.IsLagInterface) {
				isValidLag = true;
				return true;
			}
		}

		// CHECK all PORTs
		lagEntry.Ports.ToPortList().some((portIndex) => {
			ifEntry = ifTable.Find(portIndex);
			if (ifEntry == null)
				return;

			if (ifEntry.IsLagInterface) {
				isValidLag = true;
				return true;
			}
		});

		return isValidLag;
	}

	public get ConnectedDevices(): HashSet<Device> {
		var result = new HashSet<Device>();

		if (!this.Links.IsEmpty) {
			this.Links.ForEach((link) => {
				this.GetConnectedDevices(link, result);
			});
		}

		if (this.HasIfTable) {
			this.IfTable.ForEach((ifEntry) => {
				if (ifEntry.Link != null) {
					this.GetConnectedDevices(ifEntry.Link, result);
				}
			});
		}

		return result;
	}

	public ConnectedByCategory(category: DeviceCategory): HashSet<Device> {
		var result = new HashSet<Device>();
		this.ConnectedDevices.ForEach((device) => {
			if (category == null)
				result.Add(device);
			else if (device.Categories.Contains(category))
				result.Add(device);
		});

		return result;
	}

	private GetConnectedDevices(link: Link, result: HashSet<Device>) {
		link.LinkMembers.ForEach((linkMember) => {
			if (linkMember.HasDevice && linkMember.Device != this) {
				result.Add(linkMember.Device);
			}
		});
	}

	private GetNetworkLinkMember(link: Link): LinkMember {
		var networkLinkMember: LinkMember = null;

		if ((link != null) && (link.LinkMembers != null)) {
			link.LinkMembers.GetNetworkMembers().Some((linkMember) => {
				if (linkMember.HasDevice) {
					if (linkMember.Device == this)
						return;
				}
				if (!linkMember.IsNetworkMember)
					return;

				if (networkLinkMember == null)
					networkLinkMember = linkMember;
				else {
					// TO MANY NETWORK CONNECTIONS
					networkLinkMember = null;
					return true;
				}
			});
		}

		return (networkLinkMember);
	}

	public GetConnectedNetworkLinkMember(): LinkMember {
		var networkLinkMember: LinkMember = null;

		var networkMembers: LinkMemberSet = new LinkMemberSet(null);

		if (this.Links != null) {
			var tempMember: LinkMember = null;

			if (!this.Links.Every((link) => {
				tempMember = this.GetNetworkLinkMember(link);
				if (tempMember == null)
					return true;

				if (networkLinkMember == null)
					networkLinkMember = tempMember;
				else {
					// TO MANY NETWORK CONNECTIONS
					networkLinkMember = null;
					return false;
				}

				return true;
			}))
				return null;

			if (networkLinkMember == null) {
				if (this.HasIfTable) {
					var ifTable: IfTable = this.IfTable;

					ifTable.Some((ifEntry) => {
						if (!ifEntry.IsLinked)
							return;

						tempMember = this.GetNetworkLinkMember(ifEntry.Link);
						if (tempMember == null)
							return;

						if (networkLinkMember == null)
							networkLinkMember = tempMember;
						else {
							networkLinkMember = null;
							return true;
						}
					});
				}
			}
		}

		return (networkLinkMember);
	}


	public get AllLinks(): HashSet<Link> {
		var result = new HashSet<Link>();

		this.Links.ForEach((link) => {
			result.Add(link);
		});

		if (this.HasIfTable) {
			this.IfTable.ForEach((ifEntry) => {
				if (ifEntry.Link)
					result.Add(ifEntry.Link);
			});
		}

		return result;
	}

	public RemoveLink(link: Link): boolean {
		if (link == null)
			return false;

		// REMOVE from DEVICE object 
		if (this.Links.Remove(link))
			return true;

		var wasRemoved = false;

		// NOTE: If the LINK was not found on the DEVICE; check if it needs to be removed from any INTERFACES
		// REMOVE from DEVICE object (check if it was removed; if not, check INTERFACES)
		if (this.HasIfTable) {
			this.IfTable.ForEach((ifEntry) => {
				if (ifEntry.Link == link) {
					ifEntry.RemoveLink();
					wasRemoved = true;
				}
			});
		}

		return wasRemoved;
	}

	public RemoveAllLinks(): void {
		this.Links.RemoveAll();

		if (this.HasIfTable) {
			this.IfTable.ForEach((ifEntry) => {
				ifEntry.RemoveLink();
			});
		}
	}


	//public GetHashCode(): number {
	//	return this.CreateKey().GetHashCode();
	//}

	//public Equals(obj: any): boolean {
	//	if (!obj)
	//		return false;

	//	if (obj == this)
	//		return true;

	//	if (!(obj instanceof Device))
	//		return false;

	//	var other = <Device>obj;

	//	return other.CreateKey().Equals(this.CreateKey());
	//}

	//public VerifyLinkHistory(sourceDevice: Device, verifyTime: Date, addedList: List<LinkHistoryTable>): void {
	//	var targetDevice: Device = this;
	//	historyEntry: LinkHistoryEntry = null;

	//	bool sourceDeviceIsLinked = sourceDevice.IsLinked;

	//	// NO-CURRENT LINKS
	//	if (!sourceDeviceIsLinked) {
	//		// NO-HISTORY LINKS to UPDATE
	//		if (!targetDevice.HasIfLinkHistoryTable)
	//			return;
	//	}

	//	// STEP 1

	//	// NO GENERIC (non-IfEntry) LINKS found
	//	if (sourceDevice.Links.Count <= 0) {
	//		// LINKS are missing; NEED to evaluate the TARGET to see if we need to DISCONNECT any OPEN links
	//		if (targetDevice.HasIfLinkHistoryTable) {
	//			// LOOKUP - the connection point 
	//			LinkHistoryTable linkHistoryTable = targetDevice.IfLinkHistoryTable.Find(string.Empty);
	//			if (linkHistoryTable != null) {
	//				linkHistoryTable.MarkDisconnect(verifyTime);
	//			}
	//		}
	//	}

	//	// STEP 2

	//	if (sourceDeviceIsLinked) {
	//		IfLinkHistoryTable targetIfLinkHistoryTable = targetDevice.AddIfLinkHistoryTable();

	//		if (sourceDevice.HasIfTable) {
	//			LinkHistoryTable linkHistoryTable = null;

	//			IfTable ifTable = sourceDevice.IfTable;
	//			foreach(IfEntry ifEntry in ifTable)
	//			{
	//				linkHistoryTable = targetIfLinkHistoryTable.Find(ifEntry);

	//				if (!ifEntry.IsLinked) {
	//					if (linkHistoryTable != null)
	//						linkHistoryTable.MarkDisconnect(verifyTime);
	//				}
	//				else {
	//					if (linkHistoryTable == null)
	//						linkHistoryTable = targetIfLinkHistoryTable.Add(ifEntry);

	//					if (linkHistoryTable != null) {
	//						// ADD / UPDATE HISTORY
	//						historyEntry = linkHistoryTable.AddUpdateConnect(ifEntry.Link, verifyTime);

	//						// KEEP TRACK
	//						if ((historyEntry != null) && historyEntry.IsConnect) {
	//							addedList.Add(linkHistoryTable);
	//						}
	//					}
	//				}
	//			}
	//		}
	//		else {
	//			LinkHistoryTable linkHistoryTable = null;

	//			if (sourceDevice.Links.Count > 0) {
	//				// ADD/GET the GENERIC link history table
	//				linkHistoryTable = targetIfLinkHistoryTable.Add(string.Empty);

	//				foreach(Link link in sourceDevice.Links)
	//				{
	//					historyEntry = linkHistoryTable.AddUpdateConnect(link, verifyTime);

	//					// KEEP track
	//					if ((historyEntry != null) && historyEntry.IsConnect) {
	//						addedList.Add(linkHistoryTable);
	//					}
	//				}
	//			}
	//		}
	//	}
	//}

	public get HasMacAddressTable(): boolean {
		return this.HasInfoSet(InfoSetNames.MacAddressTable);
	}

	public get MacAddressTable(): MacAddressTable {
		return this.GetInfoSet<MacAddressTable>(InfoSetNames.MacAddressTable);
	}

	public AddMacAddressTable(): MacAddressTable {
		var table = this.MacAddressTable;
		if (!table) {
			table = new MacAddressTable(this);
			this.AttachInfoSet(InfoSetNames.MacAddressTable, table);
		}
		return table;
	}

	public get HasIpAddressTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IpAddressTable);
	}

	public get IpAddressTable(): IpAddressTable {
		return this.GetInfoSet<IpAddressTable>(InfoSetNames.IpAddressTable);
	}

	public AddIpAddressTable(): IpAddressTable {
		var ipAddressTable: IpAddressTable = this.IpAddressTable;
		if (!ipAddressTable) {
			ipAddressTable = new IpAddressTable(this);
			this.InfoSets.Add(InfoSetNames.IpAddressTable, ipAddressTable);
		}
		return ipAddressTable;
	}

	public get HasPortLldpTable(): boolean {
		return this.HasInfoSet(InfoSetNames.PortLldpTable);
	}

	public get PortLldpTable(): PortLldpTable {
		return this.GetInfoSet<PortLldpTable>(InfoSetNames.PortLldpTable);
	}

	public AddPortLldpTable(): PortLldpTable {
		var portLldpTable: PortLldpTable = this.PortLldpTable;
		if (!portLldpTable) {
			portLldpTable = new PortLldpTable(this);
			this.InfoSets.Add(InfoSetNames.PortLldpTable, portLldpTable);
		}
		return portLldpTable;
	}

	public FindUniqueIfEntryByMacAddress(macAddress: MacAddress): IfEntry {
		var ifEntry: IfEntry = null;

		if (this.HasMacAddressTable) {
			var macTable: MacAddressTable = this.MacAddressTable;

			var macEntry: MacAddressEntry = macTable.Find(macAddress);
			if (macEntry != null) {
				if (macEntry.IsIfUnique)
					ifEntry = macEntry.IfEntry;
			}
		}

		return (ifEntry);
	}

	public get HasApIfTable(): boolean {
		return this.HasInfoSet(InfoSetNames.ApIfTable);
	}

	public get ApIfTable(): ApIfTable {
		return this.GetInfoSet<ApIfTable>(InfoSetNames.ApIfTable);
	}

	public AddApIfTable(): ApIfTable {
		var apIfTable: ApIfTable = this.ApIfTable;
		if (!apIfTable) {
			apIfTable = new ApIfTable(this);
			this.InfoSets.Add(InfoSetNames.ApIfTable, apIfTable);
		}
		return apIfTable;
	}

	public get HasVlanTable(): boolean {
		return this.HasInfoSet(InfoSetNames.VlanTable);
	}

	public get VlanTable(): VlanTable {
		return this.GetInfoSet<VlanTable>(InfoSetNames.VlanTable);
	}

	public AddVlanTable(): VlanTable {
		var vlanTable: VlanTable = this.VlanTable;
		if (!vlanTable) {
			vlanTable = new VlanTable(this);
			this.InfoSets.Add(InfoSetNames.VlanTable, vlanTable);
		}
		return vlanTable;
	}

	public get HasIpPhoneTable(): boolean {
		return this.HasInfoSet(InfoSetNames.IpPhoneTable);
	}

	public get IpPhoneTable(): IpPhoneTable {
		return this.GetInfoSet<IpPhoneTable>(InfoSetNames.IpPhoneTable);
	}

	public AddIpPhoneTable(): IpPhoneTable {
		var ipPhoneTable: IpPhoneTable = this.IpPhoneTable;
		if (!ipPhoneTable) {
			ipPhoneTable = new IpPhoneTable(this);
			this.InfoSets.Add(InfoSetNames.IpPhoneTable, ipPhoneTable);
		}
		return ipPhoneTable;
	}

	public GetApMacAddresses(apEntry: ApEntry): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		if (apEntry != null) {
			macAddresses.Add(apEntry.MacAddress);

			if (apEntry.HasEthernetMacAddress)
				macAddresses.Add(apEntry.EthernetMacAddress);

			if (this.HasApIfTable) {
				var apIfEntries: List<ApIfEntry> = this.ApIfTable.GetApIfEntries(apEntry.MacAddress);

				apIfEntries.UnionWith(this.ApIfTable.GetApIfEntries(apEntry.EthernetMacAddress));

				apIfEntries.ForEach((apIfEntry) => {
					if (apIfEntry.HasMacAddress)
						macAddresses.Add(apIfEntry.MacAddress);
				});
			}
		}

		return (macAddresses);
	}

	public SupportsCommunityNameIndexing(): boolean {
		var supportsCNI = false;

		if (this.HasSystemInfo) {
			var sysInfo = this.SystemInfo;
			if (sysInfo.SupportsCommunityNameIndexing === TriStateBool.True) {
				if (this.HasVlanTable)
					supportsCNI = true;
			}
		}

		return supportsCNI;
	}

	public Write(obj: any, context: any): void {
		obj.device = {};
		obj = obj.device;

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);
		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);
		if (this.HasDependentDeviceId)
			this.DependentDeviceId.Write(obj, context);
		if (this.HasGUID)
			obj.guid = ValueEncoder.EncodeGuid(this.GUID);
		if (this.HasDependentDeviceGUID)
			obj.dep_dev_guid = ValueEncoder.EncodeGuid(this.DependentDeviceGUID);
		if (this.HasSNMP_Port)
			obj.snmp_port = ValueEncoder.EncodeInteger(this.SNMP_Port);
		if (this.HasSSH_Port)
			obj.ssh_port = ValueEncoder.EncodeInteger(this.SSH_Port);
		if (this.HasTelnet_Port)
			obj.telnet_port = ValueEncoder.EncodeInteger(this.Telnet_Port);
		if (this.HasCustomDisplayName)
			obj.custom_name = this.CustomDisplayName;

		this.WriteInfoSets(obj, context);

		this.Class.Write(obj, context);
		this.Categories.Write(obj, context);
		this.ProtocolProfile.Write(obj, context);

		if (this.HasTimestamp)
			obj.timestamp = this.Timestamp;
	}

	private WriteInfoSets(obj: any, context: any): void {
		obj.info_sets = {};
		obj = obj.info_sets;

		this.InfoSets.Values().ForEach((infoSet) => {
			infoSet.Write(obj, context);
		}, this);
	}

	public Read(obj: any, context: any): void {
		if (!obj.device)
			throw new Error();
		obj = obj.device;

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);
		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);
		if (obj.dependent_device_id !== undefined) {
			this.DependentDeviceId = new DependentDeviceId();
			this.DependentDeviceId.Read(obj, context);
		}
		if (obj.guid !== undefined)
			this.GUID = ValueEncoder.DecodeGuid(obj.guid);
		if (obj.dep_dev_guid !== undefined)
			this.DependentDeviceGUID = ValueEncoder.DecodeGuid(obj.dep_dev_guid);
		if (obj.info_sets !== undefined)
			this.ReadInfoSets(obj, context);
		if (obj.device_class !== undefined)
			this.Class.Read(obj, context);
		if (obj.device_categories !== undefined)
			this.Categories.Read(obj, context);
		if (obj.protocol_profile !== undefined)
			this.ProtocolProfile.Read(obj, context);
		if (obj.timestamp !== undefined)
			this.Timestamp = obj.timestamp;
		if (obj.snmp_port !== undefined)
			this.SNMP_Port = ValueEncoder.DecodeInteger(obj.snmp_port);
		if (obj.ssh_port !== undefined)
			this.SSH_Port = ValueEncoder.DecodeInteger(obj.ssh_port);
		if (obj.telnet_port !== undefined)
			this.Telnet_Port = ValueEncoder.DecodeInteger(obj.telnet_port);
		if (obj.custom_name !== undefined)
			this.CustomDisplayName = obj.custom_name;

		if (this.HasBridgePortTable) {
			if (!this.BridgePortTable.HasVlanInfo) {
				this.BridgePortTable.SyncVlanInfo();
			}
		}
	}

	private ReadInfoSets(obj: any, context: any): void {
		if (!obj.info_sets)
			throw new Error();
		obj = obj.info_sets;

		if (obj.system_info !== undefined)
			this.AddSystemInfo().Read(obj, context);

		if (obj.addr_info !== undefined)
			this.AddAddressInfo().Read(obj, context);

		if (obj.bbridge_info !== undefined)
			this.AddBaseBridgeAddressTable().Read(obj, context);

		if (obj.lag_info !== undefined)
			this.AddLagTable().Read(obj, context);

		if (obj.vrrp_info !== undefined)
			this.AddVrrpTable().Read(obj, context);

		/**/if (obj.vlan_info !== undefined)
		/**/	this.AddVlanTable().Read(obj, context);

		/**/if (obj.stp_port_info !== undefined)
		/**/	this.AddStpPortTable().Read(obj, context);

		//if (obj.sensor_info !== undefined)
		//	this.AddSensorTable().Read(obj, context);

		/**/if (obj.product_info !== undefined)
		/**/	this.AddProductInfo().Read(obj, context);

		if (obj.port_lldp_info !== undefined)
			this.AddPortLldpTable().Read(obj, context);

		/**/if (obj.product_info !== undefined)
		/**/	this.AddProductInfo().Read(obj, context);

		if (obj.asset_info !== undefined)
			this.AddAssetTable().Read(obj, context);

		/**/if (obj.bp_info !== undefined)
		/**/	this.AddBridgePortTable().Read(obj, context);

		if (obj.if_info !== undefined)
			this.AddIfTable().Read(obj, context);

		/**/if (obj.if_arp_info !== undefined)
		/**/	this.AddIfArpTable().Read(obj, context);

		/**/if (obj.bp_fdb_info !== undefined)
		/**/	this.AddBridgePortFdbTable().Read(obj, context);

		if (obj.ip_info !== undefined)
			this.AddIpAddressTable().Read(obj, context);

		/**/if (obj.inst_sw_info !== undefined)
		/**/	this.AddInstalledSoftwareTable().Read(obj, context);

		if (obj.vh_info !== undefined)
			this.AddVirtualHostInfo().Read(obj, context);

		/**/if (obj.vhs_info !== undefined)
		/**/	this.AddVirtualHostTable().Read(obj, context);

		/**/if (obj.vm_info !== undefined)
		/**/	this.AddVirtualMachineInfo().Read(obj, context);

		/**/if (obj.vms_info !== undefined)
		/**/	this.AddVirtualMachineTable().Read(obj, context);

            if (obj.w32_bios_info !== undefined)
                this.AddWin32_BIOSInfo().Read(obj, context);

		/**/if (obj.w32_comp_sys_info !== undefined)
		/**/	this.AddWin32_ComputerSystemInfo().Read(obj, context);

		/**/if (obj.w32_os_info !== undefined)
		/**/	this.AddWin32_OperatingSystemInfo().Read(obj, context);

		/**/if (obj.w32_ddrv_info !== undefined)
		/**/	this.AddWin32_DiskDriveTable().Read(obj, context);

		/**/if (obj.w32_ldsk_info !== undefined)
		/**/	this.AddWin32_LogicalDiskTable().Read(obj, context);

		/**/if (obj.w32_proc_info !== undefined)
		/**/	this.AddWin32_ProcessorTable().Read(obj, context);

		/**/if (obj.attr_info !== undefined)
		/**/	this.AddAttributeInfo().Read(obj, context);

		/**/if (obj.ap_client_info !== undefined)
		/**/	this.AddApClientTable().Read(obj, context);

		/**/if (obj.ap_if_info !== undefined)
		/**/	this.AddApIfTable().Read(obj, context);

		/**/if (obj.ap_info !== undefined)
		/**/	this.AddApTable().Read(obj, context);

		/**/if (obj.if_cdp_info !== undefined)
		/**/	this.AddIfCdpTable().Read(obj, context);

		if (obj.entity_info !== undefined)
			this.AddEntPhysicalTable().Read(obj, context);

		/**/if (obj.w32_inst_sw_info !== undefined)
		/**/	this.AddWin32_InstalledSoftwareTable().Read(obj, context);

		if (obj.w32_net_ad_cfg_info !== undefined)
			this.AddWin32_NetworkAdapterConfigTable().Read(obj, context);

		if (obj.w32_net_ad_info !== undefined)
			this.AddWin32_NetworkAdapterTable().Read(obj, context);

		/**/if (obj.ip_phones_info !== undefined)
		/**/	this.AddIpPhoneTable().Read(obj, context);

		/**/if (obj.ip_phone_info !== undefined)
		/**/	this.AddIpPhoneInfo().Read(obj, context);

		/**/if (obj.ip_route_info !== undefined)
		/**/	this.AddIpRouteTable().Read(obj, context);
	}
}